import React from "react";

// Palette pastel déterministe par utilisateur (id) plutôt qu'une seule
// couleur bordeaux fixe pour tout le monde — distingue visuellement les
// collaborateurs dans "Charge par collaborateur".
const PALETTE = [
  { bg: "bg-rose-100", text: "text-rose-700" },
  { bg: "bg-teal-100", text: "text-teal-700" },
  { bg: "bg-blue-100", text: "text-blue-700" },
  { bg: "bg-purple-100", text: "text-purple-700" },
  { bg: "bg-amber-100", text: "text-amber-700" },
  { bg: "bg-emerald-100", text: "text-emerald-700" },
];

function paletteFor(id) {
  const index = Math.abs(Number(id) || 0) % PALETTE.length;
  return PALETTE[index];
}

// variant="palette" (défaut) : couleur pastel dérivée de l'id, utilisée dans
// les cartes "Charge par collaborateur". variant="solid" : bordeaux fixe,
// utilisée dans les cellules Collaborateur du tableau.
function AvatarInitials({ id, name, lastName, size = "w-7 h-7", textSize = "text-[10px]", variant = "palette" }) {
  const initials = `${name?.[0] || ""}${lastName?.[0] || ""}`.toUpperCase();
  const { bg, text } = variant === "solid" ? { bg: "bg-[#5C1A30]", text: "text-white" } : paletteFor(id);
  return (
    <div
      className={`${size} rounded-full ${bg} ${text} flex items-center justify-center font-bold uppercase flex-shrink-0 ${textSize}`}
    >
      {initials || "?"}
    </div>
  );
}

export default AvatarInitials;
